import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import Tooltip from 'components/Tooltip';

export const ToggleButton = ({
  buttonStyle,
  count,
  text,
  updateChartWithFilter,
  filterType,
  code,
  filterTypeStyle,
  imgIcon,
  description,
}) => (
  <button
    className={buttonStyle}
    style={filterTypeStyle}
    onClick={() => updateChartWithFilter(filterType, code)}
  >
    {filterType !== 'priceBands' && (
      <Tooltip
        tooltipText={`${code} - ${description}`}
        preventClick={true}
        position="left"
        tooltipHelperStyle={{ maxWidth: '225px' }}
      />
    )}
    {filterType === 'priceBands' && (
      <span className={styles.sectionHeader}>{`PB${code}`}</span>
    )}
    <span className={styles.buttonText}>
      {imgIcon && (
        <img src={imgIcon} alt="filter icon" className={styles.filterIcon} />
      )}
      <span>{text}</span>
      <span>({count})</span>
    </span>
  </button>
);

export default enhance(ToggleButton);
